import { useState } from 'react';

export const useSidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    return isSidebarOpen
  };

  return {
    isSidebarOpen,
    toggleSidebar,
  };
};
